<template>
    <div class="dingdan">
<!--        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单全流程'}]"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                	<div class="h-thirdColumn w-newColumn">
                		<el-form-item label="订单编号" prop="sapCodeLike" style="width: 50%;">
                		    <el-input v-model="formInline.sapCodeLike" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                		</el-form-item>
                		<el-form-item label="　售达方编码/名称" prop="sdfCodeNameLike">
                		    <el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入"
                		              style="width: 100%"></el-input>
                		</el-form-item>
                		<el-form-item label="订单类型" prop="orderCategory">
                		    <brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
                		              v-model="formInline.orderCategory" clearable
									  :disabled="ddlxdisabled"
                		              @change="changeOrderCate"
                		              ></brselect>
                		</el-form-item>
                	</div>
                	<el-collapse-transition>
                		<div v-show="isScreen">
                			<div class="h-thirdColumn w-newColumn">
                				<el-form-item label="　　订单子类型" prop="orderCategory">
                				    <el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
                				        <el-option v-for="item in orderCategory1List"
                				                   :key="item.code"
                				                   :label="item.name"
                				                   :value="item.code">
                				        </el-option>
                				    </el-select>
                				</el-form-item>
                				<el-form-item label="是否异地" prop="shifouyidi">
                				    <el-select v-model="formInline.shifouyidi" :clearable="true">
                				        <el-option label="异地" value="1"></el-option>
                				        <el-option label="非异地" value="0"></el-option>
                				    </el-select>
                				</el-form-item>
                				<el-form-item label="直销/分销" prop="disChannelCode">
                				    <el-select v-model="formInline.disChannelCode" :clearable="true">
                				        <el-option label="直销" value="Z1"></el-option>
                				        <el-option label="分销" value="00"></el-option>
                				    </el-select>
                				</el-form-item>
                				<el-form-item label="是否高于基准价" prop="gaobenchmark">
                				    <el-select v-model="formInline.gaobenchmark" :clearable="true">
                				        <el-option label="等于" value="1"></el-option>
                				        <el-option label="高于" value="2"></el-option>
                				        <el-option label="低于" value="3"></el-option>
                				    </el-select>
                				</el-form-item>
                			</div>
                			<div class="h-thirdColumn w-newColumn">
                				<el-form-item label="订单状态" prop="status">
                				    <brselect clearable category="order_status" :v="formInline.statusData"
                                      :multiple="true"   v-model="formInline.statusData"></brselect>
                				</el-form-item>
                				<el-form-item label="　　信用检查状态" prop="add1">
                				    <el-select v-model="formInline.add1" :clearable="true">
                				        <el-option label="信用检查通过" value="A"></el-option>
                				        <el-option label="信用检查不通过" value="B"></el-option>
                				        <el-option label="信用检查批准通过" value="D"></el-option>
                				    </el-select>
                				</el-form-item>
                				<el-form-item label="商品大类" prop="proModelCode">
                				    <brselect clearable category="product_level" :v="formInline.proModelCode"
                				              v-model="formInline.proModelCode"></brselect>
                				</el-form-item>
                				<el-form-item label="自产 /OEM" prop="prodtype">
                				    <el-select v-model="formInline.prodtype" :clearable="true"
                				               placeholder="请选择">
                				        <el-option label="自产" value="自产"></el-option>
                				        <el-option label="OEM" value="OEM"></el-option>
                				    </el-select>
                				</el-form-item>
                			</div>
                			<div class="h-thirdColumn w-newColumn">
                				<el-form-item label="　　安排发货时间" class="ddqlcpicker" style="width: 50%;">
                					<el-date-picker
                							placeholder="请选择"
                					        v-model="formInline.fhdate1"
                					        clearable
                					        type="date"
                					        value-format="yyyy-MM-dd" >
                					</el-date-picker>
                					<span class="w-time-to">至</span>
                					<el-date-picker
                							placeholder="请选择"
                					        v-model="formInline.fhdate2"
                					        clearable
                					        type="date"
                					        value-format="yyyy-MM-dd" >
                					</el-date-picker>
                				</el-form-item>
                				<el-form-item label="地区" prop="soldToAreaCode">
                				    <brselect clearable category="YLRegion" :v="formInline.soldToAreaCode"
                				              v-model="formInline.soldToAreaCode"></brselect>
                				</el-form-item>
                				<el-form-item label="收益区域" prop="shouyiarea">
                				    <brselect clearable category="YLRegion" :v="formInline.shouyiarea"
                				              v-model="formInline.shouyiarea"></brselect>
                				</el-form-item>
                			</div>
                			<div class="h-thirdColumn w-newColumn">
                				<el-form-item label="　　订单创建时间" style="width: 50%;">
                					<el-date-picker
                							placeholder="请选择"
                					        v-model="formInline.date1"
                					        clearable
                					        type="date"
                					        value-format="yyyy-MM-dd" >
                					</el-date-picker>
                					<span class="w-time-to">至</span>
                					<el-date-picker
                							placeholder="请选择"
                					        v-model="formInline.date2"
                					        clearable
                					        type="date"
                					        value-format="yyyy-MM-dd" >
                					</el-date-picker>
                				</el-form-item>
                				<el-form-item label="　　发票是否创建" prop="billingStatus" >
                				    <brselect clearable category="pgiStatus" :v="formInline.billingStatus"
                				              v-model="formInline.billingStatus"></brselect>
                				</el-form-item>
                                <el-form-item label="销售组织" prop="saleGroupCodeList">
                                    <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCodeList" :showcode="true"
                                              v-model="formInline.saleGroupCodeList" :multiple="true" :collapse-tags="true"  clearable></brselect>

                                </el-form-item>
                			</div>
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="最后审核日期" prop="lastSptgTime" style="width: 50%;">
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.taskEnddateBg"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.taskEnddateEd"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
								<el-form-item label="　产品编码/名称" prop="materialCodeNameLike">
									<el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input>
								</el-form-item>
								<el-form-item label="是否血站订单" prop="isBlood">
                                <brselect clearable category="shifou_keyong" :v="formInline.isBlood"
                                            v-model="formInline.isBlood"></brselect>
                                    <!-- <el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input> -->
                                </el-form-item>
							</div>
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="业绩所属月份" prop="taskEnddate" style="width: 50%;">
									<div class="block">
										<el-date-picker
												v-model="formInline.businessTime"
												type="month"
												placeholder="选择月"
												value-format="yyyyMM">
										</el-date-picker>
									</div>
								</el-form-item>
								<el-form-item label="签收状态" prop="thawStatus">
									<el-select v-model="formInline.thawStatus" :clearable="true"
											   placeholder="请选择">
										<el-option label="已签收" value="Y"></el-option>
										<el-option label="未签收" value="N"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="签收日期(OMS)" class="ddqlcpicker" style="width: 50%;">
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.acceptTimeStart"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.acceptTimeEnd"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
								<el-form-item label="共享大类" prop="shareModelCode">
									<brselect :v="formInline.shareModelCode"    category="product_level" v-model="formInline.shareModelCode"
											  clearable placeholder="请选择"></brselect>
								</el-form-item>
							</div>
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="套餐订单号" prop="packageOrderCode">
									<el-input v-model="formInline.packageOrderCode" placeholder="请输入"
											  style="width: 100%"></el-input>
								</el-form-item>
								<el-form-item label="分销商订单号" prop="secondSapCode"  style="width: 50%;">
									<el-input v-model="formInline.secondSapCode" placeholder="请输入"  ></el-input>
								</el-form-item>
								<el-form-item label="分销商编码/名称" prop="secondLevelAgentLike">
									<el-input v-model="formInline.secondLevelAgentLike" placeholder="请输入"
											  style="width: 100%"></el-input>
								</el-form-item>
							</div>
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="实际发货日期" prop="delTime" style="width: 50%;">
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.delTimeStart"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
											placeholder="请选择"
											v-model="formInline.delTimeEnd"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>

                <el-form-item label="产地" >
                  <brselect category="factory" :v="formInline.chandidata" :showcode="true"
                            v-model="formInline.chandidata" :multiple="true" :collapse-tags="true" clearable></brselect>
                </el-form-item>

                <!--<el-form-item label="开票日期" prop="delTime" style="width: 50%;">
                  <el-date-picker
                      placeholder="请选择"
                      v-model="formInline.add5Begin"
                      clearable
                      type="date"
                      value-format="yyyy-MM-dd" >
                  </el-date-picker>
                  <span class="w-time-to">至</span>
                  <el-date-picker
                      placeholder="请选择"
                      v-model="formInline.add5End"
                      clearable
                      type="date"
                      value-format="yyyy-MM-dd" >
                  </el-date-picker>
                </el-form-item>-->
							</div>
                		</div>
                	</el-collapse-transition>
                </el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
					</div>
				</div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="作废订单" :visible.sync="zfyydialogFormVisible">
            <el-form :model="zuofeiyy">
                <el-form-item label="作废原因" :label-width="100">
                    <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
                              v-model="zuofeiyy.yy" ></brselect>
                </el-form-item>
                <el-form-item label="备注" :label-width="100">
                    <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="zfyydialogFormVisible = false">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitzuofei">确 定</el-button>
            </div>
        </el-dialog>

      <el-dialog
          :visible.sync="showUpdateBusinessDateFlag"
          v-if="showUpdateBusinessDateFlag"
          class="h-dialog2"
      >
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>修改归属月份</h1>
            </div>
          </div>
        </div>
        <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
          <h3 style="display: inline-block;">订单号:</h3>
          <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{BusinessDate.sapCodesStr}}</h4>
        </div>
        <div class="h-formLine" style="width:250px;padding:20px;">
          <h3 style="display: inline-block;">业绩归属月份</h3>
          <el-date-picker
              v-model="BusinessDate.businessDate"
              type="month"
              clearable
              placeholder="选择日期"
              value-format="yyyyMM">
          </el-date-picker>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="showUpdateBusinessDateFlag = false">取 消</el-button>
          <el-button class="h-btn h-bBtn" @click="submitBusinessDate">提 交</el-button>
        </div>
      </el-dialog>








        <div class="h-table h-mrt30">
            <el-table
				@selection-change="handleSelectionChange"
				ref="ddtable"
				:data="tableData"
				:span-method="objectSpanMethod"
				stripe
				border
				:show-overflow-tooltip="true"
				style="width: 100%"
				max-height="520"
			>
			   <el-table-column
				   type="selection"
				   width="40"
				   :label="all"
			   >
			   </el-table-column>
				<el-table-column
					type="index"
					label="#"
					fixed
					width="40">
				</el-table-column>
				<el-table-column
					prop="sapCode"
					label="订单号"
					fixed
					:show-overflow-tooltip="true"
					width="120">
				</el-table-column>

				<el-table-column
					prop="soldToName"
					label="经销商"
					fixed
					:show-overflow-tooltip="true"
					width="150">
					<template slot-scope="scope">
						<div style="text-align: left;" :title="scope.row.soldToName">
							{{scope.row.soldToName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="materialName"
					label="商品名称"
					fixed
					:show-overflow-tooltip="true"
					width="150">
					<template slot-scope="scope">
						<div style="text-align: left;" :title="scope.row.materialName">
							{{scope.row.materialName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="xiaoe"
						label="是否计入销额"
						width="120"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						<div :class="{'redclass':scope.row.seriestrue == 0}">
							{{scope.row.xiaoe | dictname('xiaoe_jishu')}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="jishu"
						label="是否计入基数"
						width="120"
						:show-overflow-tooltip="true"
				>
					<template slot-scope="scope">
						<div :class="{'redclass':scope.row.seriestrue == 0}">
							{{scope.row.jishu | dictname('xiaoe_jishu')}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="lianqun"
						label="签约链群"
						:show-overflow-tooltip="true"
						width="90">
					<template scope="scope">
						{{scope.row.lianqun|dictname('xsyb_lianqun')}}
					</template>
				</el-table-column>
        <!--  返利归属产业与签约链群对应关系 取得字典表refid字段      -->
        <el-table-column
            prop="lianqun"
            label="返利归属产业"
            :show-overflow-tooltip="true"
            width="90">
            <template scope="scope">
                {{scope.row.lianqun|dictrefid('xsyb_lianqun')}}
            </template>
        </el-table-column>


				<el-table-column
					prop="oemDesc"
					label="规格型号"
					width="140"
					:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
					prop="spbmjcmtlgroupname"
					label="开票名称"
					width="240"
					:show-overflow-tooltip="true"
				>
				</el-table-column>
				<el-table-column
						prop="waybillName"
						label="物流名称"
						width="150">
					<template slot-scope="scope">
						<div style="text-align: left;" :title="scope.row.waybillName">
							{{scope.row.waybillName}}
						</div>
					</template>
				</el-table-column>

				<el-table-column
						prop="waybillId"
						label="物流单号"
						width="150">
					<template slot-scope="scope">
						<div style="text-align: left;" :title="scope.row.waybillId">
							{{scope.row.waybillId}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="proNumber"
					label="数量"
					width="60">
						<template slot-scope="scope">
							<div style="text-align: right;" :title="scope.row.proNumber">
								{{scope.row.proNumber}}
							</div>
						</template>
				</el-table-column>
				<el-table-column
					prop="note"
					label="备注"
					:show-overflow-tooltip="true"
					min-width="180">
						<template slot-scope="scope">
							<div style="text-align: left;" :title="scope.row.note">
								{{scope.row.note}}
							</div>
						</template>
				</el-table-column>
				<el-table-column
					prop="prodtype"
					label="自产/OEM"
					width="100">
					<template scope="scope">
						<div style="text-align: left;" v-if="scope.row.saleGroupCode != '1R60' || adminFlag">
							{{scope.row.prodtype}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
						prop="shareModelName"
						label="共享大类"
						width="100">
					<template slot-scope="scope">
						<div style="text-align: center;" :title="scope.row.shareModelName">
							{{scope.row.shareModelName}}
						</div>
					</template>
				</el-table-column>

				<el-table-column
						prop="isSecondOrder"
						label="是否分销商订单"
						width="100">
				</el-table-column>
				<el-table-column
						prop="secondLevelAgentName"
						label="分销商名称"
						width="100">
				</el-table-column>
				<el-table-column
						prop="secondSapCode"
						label="分销商订单号"
						width="100">
				</el-table-column>

				<el-table-column
					prop="materialCode"
					label="商品编码"
					width="110">
					<template slot-scope="scope">
						<div :title="scope.row.materialCode">
							{{scope.row.materialCode}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="status"
					label="订单状态"
					width="100">
					<template scope="scope">
						{{scope.row.status|dictname('order_status')}}
					</template>
				</el-table-column>
				<el-table-column
					prop="orderCategory"
					label="订单类型"
					:show-overflow-tooltip="true"
					width="150">
					<template scope="scope">
						{{scope.row.orderCategory|dictname('xiaoshou_quyu') }}
						{{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
					</template>
				</el-table-column>
	<!--			<el-table-column
						prop="waybillName"
						label="物流公司"
						:show-overflow-tooltip="true"
						width="120">
				</el-table-column>-->
				<el-table-column
					prop="saleGroupCode"
					label="销售组织"
					:show-overflow-tooltip="true"
					width="260">
					<template scope="scope">
						<div style="text-align: left;">
							[{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
						</div>
					</template>
				</el-table-column>
        <el-table-column
            prop="factory"
            label="工厂"
            :show-overflow-tooltip="true"
            width="110">
        </el-table-column>
				<el-table-column
					prop="add3"
					label="DN单号"
					:show-overflow-tooltip="true"
					width="120">
				</el-table-column>
				<el-table-column
					prop="add2"
					label="SO单号"
					:show-overflow-tooltip="true"
					width="120">
				</el-table-column>

				<el-table-column
					prop="add1"
					label="信用检查状态"
					:show-overflow-tooltip="true"
					width="120">
					<template scope="scope">
						{{scope.row.add1|dictname('xinyong_zhuangtai')}}
					</template>
				</el-table-column>

				<el-table-column
					prop="iszhidan"
					label="经销商类型"
					:show-overflow-tooltip="true"
					width="110">
					<template scope="scope">
						{{scope.row.iszhidan|dictname('dailishang_leixing')}}
					</template>
				</el-table-column>
				<el-table-column
					prop="soldToCode"
					label="经销商编码"
					width="110">
				</el-table-column>
				<el-table-column
					prop="proModelName"
					label="商品大类"
					:show-overflow-tooltip="true"
					width="100">
				</el-table-column>
				<el-table-column
					prop="tejiashuoming"
					label="特价描述"
					:show-overflow-tooltip="true"
					width="180">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.tejiashuoming}}
							</div>
						</template>
				</el-table-column>
				<el-table-column
					prop="sid"
					label="特价版本号"
					:show-overflow-tooltip="true"
					width="180">
				</el-table-column>
				<el-table-column
					prop="orderProjectCode"
					label="工程版本号"
					:show-overflow-tooltip="true"
					width="180">
				</el-table-column>
				<el-table-column
					prop="finalPrice"
					label="单价"
					:show-overflow-tooltip="true"
					width="70">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.finalPrice}}
							</div>
						</template>
				</el-table-column>

				<el-table-column
					prop="totalprice"
					label="总价"
					:show-overflow-tooltip="true"
					width="70">
					<template slot-scope="scope">
						<div style="text-align: right;">
							{{scope.row.totalprice}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="orderNetWorth"
					label="净收入/净价值"
					:show-overflow-tooltip="true"
					width="130">
						<template slot-scope="scope">
							<div style="text-align: right;">
								{{scope.row.orderNetWorth}}
							</div>
						</template>
				</el-table-column>
				<el-table-column
						prop="currencyCode"
						label="币种"
						:show-overflow-tooltip="true"
						width="70">
					<template slot-scope="scope">
						<div style="text-align: right;">
							{{scope.row.currencyCode}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="shouyiarea"
					label="收益区域"
					:show-overflow-tooltip="true"
					width="90">
					<template scope="scope">
						{{scope.row.shouyiarea|dictname('YLRegion')}}
					</template>
				</el-table-column>
				<el-table-column
						prop="shouyiChannel"
						label="收益渠道"
						:show-overflow-tooltip="true"
						width="90">
					<template scope="scope">
						{{scope.row.shouyiChannel|dictname('sales_region')}}
					</template>
				</el-table-column>

				<el-table-column
					prop="shifouyidi"
					label="是否异地"
					:show-overflow-tooltip="true"
					width="90">
					<template scope="scope">
						{{scope.row.shifouyidi|dictname('shifou_keyong')}}
					</template>
				</el-table-column>

				<el-table-column
					prop="soldToAreaName"
					label="售达方区域"
					:show-overflow-tooltip="true"
					width="110">
				</el-table-column>
				<el-table-column
					prop="shipToAreaName"
					label="送达方区域"
					:show-overflow-tooltip="true"
					width="110">
				</el-table-column>
				<el-table-column
					prop="yejiarea"
					label="业绩所属区域"
					:show-overflow-tooltip="true"
					width="110">
				</el-table-column>


				<el-table-column
					prop="customerChannelCode"
					label="销售渠道"
					:show-overflow-tooltip="true"
					width="90">
					<template scope="scope">
						{{scope.row.customerChannelCode|dictname('sales_region')}}
					</template>
				</el-table-column>
				<el-table-column
					prop="toCompanyname"
					label="收货单位"
					:show-overflow-tooltip="true"
					width="180">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.toCompanyname}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="contactName"
					label="联系人"
					:show-overflow-tooltip="true"
					width="80">
				</el-table-column>
				<el-table-column
					prop="firsttelephone"
					label="电话"
					:show-overflow-tooltip="true"
					width="120">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.firsttelephone}}
							</div>
						</template>
				</el-table-column>

				<el-table-column
					prop="soldToName"
					label="省市名称"
					:show-overflow-tooltip="true"
					width="110">
					<template scope="scope">
						{{ `${scope.row.toProvincesName || ''}${scope.row.toCityName || ''}`}}
					</template>
				</el-table-column>
				<el-table-column
					prop="toAddress"
					label="详细地址"
					:show-overflow-tooltip="true"
					width="180">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.toAddress}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="isStockUp"
					label="是否备货"
					:show-overflow-tooltip="true"
					width="90">
					<template scope="scope">
						{{scope.row.isStockUp|dictname('shifou_keyong')}}
					</template>
				</el-table-column>

				<el-table-column
					prop="cdate0"
					label="创建时间"
					:formatter="formatDate"
					width="160">
				</el-table-column>
				<el-table-column
						prop="dnCreateTime"
						label="交货单创建时间"
						width="160">
				</el-table-column>
				<el-table-column
					prop="receivedTime"
					label="预期收货时间"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
	<!--                <el-table-column-->
	<!--                        prop="sptgTime"-->
	<!--                        label="审核通过时间"-->
	<!--						:show-overflow-tooltip="true"-->
	<!--                        width="220">-->
	<!--                </el-table-column>-->
				<el-table-column
					prop="sptgTime"
					label="销售订单生成日期"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
						prop="fhdate"
						label="安排发货时间"
						:show-overflow-tooltip="true"
						:formatter="formatDate"
						:key="Math.random()"
						width="160">
				</el-table-column>
				<el-table-column
					prop="delTime"
					label="生成发货计划时间"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
					prop="wlyjfh"
					label="计划发货日期"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
					prop="wlyjdh"
					label="计划到货日期"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
					prop="delTime"
					label="实际发货日期"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
					prop="arrTime"
					label="实际到货日期"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
					prop="nxEightTime"
					label="客户签收日期"
					:formatter="formatDate"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
						prop="taxCode"
						label="税分类编码"
						:show-overflow-tooltip="true"
						width="180">
				</el-table-column>
				<el-table-column
					prop="bktxt"
					label="纸质发票号"
					:show-overflow-tooltip="true"
					width="150">
				</el-table-column>
        <el-table-column
            prop="serialNumber"
            label="流水号"
            :show-overflow-tooltip="true"
            width="150">
        </el-table-column>
				<el-table-column
					prop="arStatus"
					label="是否清账"
					:show-overflow-tooltip="true"
					width="90">
					<template scope="scope">
						{{scope.row.arStatus|dictname('pgiStatus')}}
					</template>
				</el-table-column>
				<el-table-column
					prop="billingStatus"
					label="发票是否创建"
					:show-overflow-tooltip="true"
					width="120">
					<template scope="scope">
						{{scope.row.billingStatus|dictname('pgiStatus')}}
					</template>
				</el-table-column>
				<el-table-column
					prop="disChannelCode"
					label="分销渠道"
					:show-overflow-tooltip="true"
					width="110">
					<template scope="scope">
						{{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
					</template>
				</el-table-column>
				<el-table-column
					prop="add4"
					label="系统发票号"
					:show-overflow-tooltip="true"
					width="160">
				</el-table-column>
				<el-table-column
					prop="add5"
					label="开票时间"
					:formatter="formatDate8"
					width="120">
				</el-table-column>
				<el-table-column
					prop="ldate"
					label="最后更新时间"
					width="160"
					:formatter="formatDate"
					:show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column
						prop="lastSptgTime"
						label="最后审核日期"
						:show-overflow-tooltip="true"
						:formatter="formatDate"
						width="160">
				</el-table-column>
				<el-table-column
						prop="acceptTime"
						label="签收日期(OMS)"
						:formatter="formatDate"
						:show-overflow-tooltip="true"
						width="130">
				</el-table-column>
				<el-table-column
						prop="thawStatus"
						label="签收状态"
						:show-overflow-tooltip="true"
						width="110">
					<template scope="scope">
						<span v-if="scope.row.thawStatus == 'N'">未签收</span>
						<span v-if="scope.row.thawStatus == 'Y'">已签收</span>
					</template>
				</el-table-column>
				<el-table-column
						prop="acceptTimeN"
						label="业绩所属月份"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
				<el-table-column
						prop="packageOrderCode"
						label="套餐订单号"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
				<el-table-column
						prop="priceType"
						label="费用名称"
						width="120"
						:show-overflow-tooltip="true">
					<template scope="scope">
						{{scope.row.priceType|dictname('price_type') }}
					</template>
				</el-table-column>
				<el-table-column
						prop="nextDbrcode"
						label="下一审批人工号"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
				<el-table-column
						prop="nextDbrname"
						label="下一审批人"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
				<el-table-column
						prop="nextDbnode"
						label="下一审批节点"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
				<el-table-column
						prop="cuname"
						label="订单创建人"
						:show-overflow-tooltip="true"
						width="110">
				</el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="270"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;" v-if="null != scope.row.sapCode && '' != scope.row.sapCode && scope.row.sapCode.indexOf('PF') == -1">
                            <el-button
                                    size="small" class="h-tableLink h-btn"
                                    @click="handelDetail(scope.row)">查看
                            </el-button>
                        	<el-button v-if="scope.row.binstid"
									   :key="Math.random()"
                        			   size="small" class="h-tableLink h-btn"
                        			   @click="genzongLiuch(scope.row)">
                        		跟踪
                        	</el-button>
                        	<el-button
                        			v-if="scope.row.status < 50"
									v-auth="'zuofeidingdan'"
									:key="Math.random()"
                        			size="small" class="h-tableLink h-btn"
                        			@click="sapDeleteOrder(scope.row)">作废
                        	</el-button>
                          <el-button
                              size="small" class="h-tableLink h-btn"
							  v-if="scope.row.serialNumber != null && scope.row.serialNumber != ''"
                              @click="getInvoiceCode(scope.row.serialNumber)">发票下载
                          </el-button>
							<el-button
									v-if="(scope.row.nxThreeTime||false) && (scope.row.orderCategory == '1')"
									:key="Math.random()"
									size="small" class="h-tableLink h-btn"
									@click="openWuliu(scope.row.sapCode)">物流跟踪
							</el-button>
						  <el-button
							        v-if = "(isfpprint) && (scope.row.status == '60'
									|| scope.row.status == '50' ||scope.row.status == '100') "
                                    size="small" class="h-tableLink h-btn"
                                    @click="printlnFhd(scope.row.sapCode)">发货单打印
                            </el-button>
						</div>
                    </template>
                </el-table-column>
            </el-table>
          <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
          <pagination :page="formInline" @query="query"/>
          <div style="display:flex;align-items: center;">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel" v-if="!isShield">批量导出
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-if="adminFlag"
                       @click="showBusinessDate">修改归属月份
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-auth="'createxiaoshoucontract'"
                       @click="createInvoice">发货通知单
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-auth="'createxiaoshoucontract'"
                       @click="createInvoicepdf">发货通知单pdf
            </el-button>
          </div>
          </div>
        </div>
      <el-dialog :visible.sync="lookPdfflag" width="100%" top="0">
        <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
      </el-dialog>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        props: ["firstPageFlag"],
        data() {
            return {
              adminFlag:false,
              showUpdateBusinessDateFlag:false,
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                instid: null,
                showhistory: null,
                value2:'',
                imgflag3: false,
                orderTypeList: [],

                orderCategory1AllList:[],
                orderCategory1List:[],
                ddlxdisabled:false,

				businessTime: '',

                tableData: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                isShield:false,//法务屏蔽导出
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                //表单
                formInline: {
                    wlyjfh:null,
                    wlyjfh1:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    thawStatus:null,
                    soldToAreaCode: '',
                    proModelName: '',
                    add1: '',
                    status: '',
                    sapCodeLike: '',
                    sdfCodeNameLike: '',
					materialCodeNameLike:'',
                    orderCategory: '',
                    date1: null,
                    date2: null,
                    fhdate1:null,
                    fhdate2:null,
                    qrfhdate1:null,
                    qrfhdate2:null,
                    gaobenchmark: '',
                    shifouyidi: '',
                    disChannelCode: '',
                    prodtype:null,
                    billingStatus: '',
                    saleGroupCode: '',
                    saleGroupCodeList:[],
		    		isBlood:'',
					taskEnddateBg:'',
					taskEnddateEd:'',
					businessTime: '',
                    nxEightTimeBegin:'',
                    nxEightTimeEnd:'',
					acceptTimeStart:'',
					acceptTimeEnd:'',
					packageOrderCode:'',
					secondLevelAgentLike:"",
					secondSapCode:"",
					delTimeStart:"",
					delTimeEnd:"",
					add5Begin:"",
					add5End:"",
           statusData:"",
                },
                spanArr: [],
                all: '全部',
                //作废原因
                zfyydialogFormVisible:false,
                zuofeiyy:{
                    id:null,
                    yy:null,
                    bz:null,
                },

              BusinessDate:
                  {
                    sapCodesStr:null,
                    sapCodes:[],
                    businessDate:null,
                  },
                //表格
                multipleSelection: [],
              pdfUrl:null,
              lookPdfflag: false,
                f: {
                    status: '',
                    sapCodeLike: '',
                    sdfCodeNameLike: '',
					materialCodeNameLike:'',
                    orderCategory: '',
                    date1: null,
                    date2: null,
                    gaobenchmark: '',
                    shifouyidi: '',
                    disChannelCode: '',
                },
				newDate1: null,
				newDate2: null,
            }
        },


        created() {
          if (this.$store.getters.hasRole('update_gsyf')) {
            this.adminFlag = true;
          }
          if (this.$store.getters.hasRole('swyl_fawu')) {
            this.isShield = true;
          }
		if (this.$store.getters.hasRole('swyl_admin')
		||this.$store.getters.hasRole('swyl_gndailishang')
		||this.$store.getters.hasRole('swyl_dingdgly')
		||this.$store.getters.hasRole('xtgly-new')) {
            this.isfpprint = true;
          }


			this.setSelectDate();
            this.query();
			this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
            if(this._user.usercode == '00206338'){
                this.ddlxdisabled = true;

                this.formInline.orderCategory=1;
                this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:"201910254L3O3bAL"});
            }
        },
		beforeRouteLeave(to, from, next) {
			from.meta.keepAlive = false;
			next();
		},
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},


            /*↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓行合并↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].id === this.tableData[index - 1].id) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },

            //修改业务所属月份
            showBusinessDate(row)
           {
             this.BusinessDate.businessDate=null;
             var flag = false;
             var flag1=false;
             this.multipleSelection.forEach((item, index) => {
               if(item.thawStatus != 'Y'){
                 flag = true;
                 return;
               }

               if(item.acceptTime ==null)
               {
                 flag1 = true;
                 return;
               }

             })



            if(flag){
               this.$msg.msge("请核查,选择的订单必须都是已签收状态才可以修改归属月份！");
               return;
             }
             if(flag1){
               this.$msg.msge("请核查,选择的订单必须已存在签收日期才可以修改归属月份！");
               return;
             }

             var sapCodes=[];
             this.multipleSelection.forEach((item, index) => {
               sapCodes.push(item.sapCode);
             })

             this.BusinessDate.sapCodes =sapCodes;

             var str = '';
             for(var i=0;i<sapCodes.length;i++){
               str += sapCodes[i] + ',';
             }
             str = str.substring(0,str.length-1);
             this.BusinessDate.sapCodesStr = str;
             this.showUpdateBusinessDateFlag = true;
           },
          createInvoice(){
              console.log(this.multipleSelection)
            let flag = true;
            for (let i = 0; i < this.multipleSelection.length; i++) {
              //如果不是退货订单并且 外销组合订单放开先打印发货单
              if ('14' != this.multipleSelection[i].orderCategory1 && this.multipleSelection[i].sapCode.indexOf("-") == -1){
                if (50 != this.multipleSelection[i].status && 60 != this.multipleSelection[i].status  && 100 != this.multipleSelection[i].status && '44' != this.multipleSelection[i].orderCategory1){
                  this.$msg.msge(this.multipleSelection[i].sapCode + "订单未安排发货，无法生成发货通知单");
                  return;
                }
              }else {
                flag = false;
              }
            }
            ss.OrderMainService.createInvoice(this.multipleSelection).then(res => {
              const link = document.createElement('a')
              let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
              link.style.display = 'none'
              link.href = URL.createObjectURL(blob);
              if (flag){
                link.setAttribute('download', `发货通知单.xlsx`)
              }else {
                link.setAttribute('download', `退货通知单.xlsx`)
              }
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            });
          },
          createInvoicepdf(){
            let flag = true;
            for (let i = 0; i < this.multipleSelection.length; i++) {
              //如果不是退货订单并且
              if ('14' != this.multipleSelection[i].orderCategory1 && this.multipleSelection[i].sapCode.indexOf("-") == -1){
                if (50 != this.multipleSelection[i].status && 60 != this.multipleSelection[i].status  && 100 != this.multipleSelection[i].status){
                  this.$msg.msge(this.multipleSelection[i].sapCode + "订单未安排发货，无法生成发货通知单");
                  return;
                }
              }else {
                flag = false;
              }
            }
            ss.OrderMainService.createInvoicePdf(this.multipleSelection).then(res => {
              const blob = new Blob([res], { type: 'application/pdf' })
              this.pdfUrl = URL.createObjectURL(blob)
              this.lookPdfflag= true;
            });
          },
            //作废订单
            sapDeleteOrder(row) {
                if (row.status == '10') {
                    this.$msg.confirm("确认作废?", () => {
                        ss.OrderMainService.sapDeleteOrder(row.bid, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.bid
                    this.zfyydialogFormVisible = true;
                }
            },
            submitzuofei(){
                if (!this.zuofeiyy.yy) {
                    this.$msg.msge("请选择作废原因");
                    return false;
                }
                var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
                this.$msg.confirm("确认作废?", () => {
                    ss.OrderMainService.sapDeleteOrder(this.zuofeiyy.id, yybz).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                        this.zfyydialogFormVisible = false
                    });
                });
            },
          submitBusinessDate()
          {
            if (!this.BusinessDate.sapCodesStr ) {
              this.$msg.msge("无指定订单号,无法提交");
              return false;
            }
            var sapCodes=this.BusinessDate.sapCodesStr;
            console.log("sapCodes="+sapCodes);
            var businessDate=this.BusinessDate.businessDate;

            this.$msg.confirm("确认修改业绩归属日期?", () => {
              ss.OrderMainService.updateBusinessDate(sapCodes,businessDate).then(rd => {
                this.$msg.msgs(rd.msg);
                this.query();
                this.showUpdateBusinessDateFlag = false
              });
            });

          },
            //跟踪
            genzongLiuch(r) {
                console.log(r);
                if (r.orderCategory == '1' || r.orderCategory == '3') {
                    this.instid = r.binstid;
                } else {
                    this.instid = r.instid;
                }
                this.showhistory = true;
            },

			printlnFhd(sapcode){
				console.log(sapcode,"sapcode111122222");
				// sapcode = "SWN0189601";
				ss.OrderMainService.getFhdPrintPdf(sapcode).then(rd => {
                    if(rd.f&&rd.obj){
						console.log(rd.obj);
						window.open(rd.obj);
					}

			});
		},

          //发票下载
      getInvoiceCode(number){
        ss.OrderMainService.getInvoiceObtain(number).then(rd => {
          console.log("rd",rd.msg.invoiceUrl)
          if(rd.f && rd.msg.invoiceUrl != null && rd.msg.invoiceUrl != ''){

            //window.location.href = rd.msg.invoiceUrl;
            window.open(rd.msg.invoiceUrl, "_blank");
          }else {
            this.$msg.msge("未查询到发票信息!");
            return false;
          }
        });
      },

			openWuliu(sapcode){
                // https://ylwl.haierbiomedical.com/siteWaybillInfo/mdlgenzongDetail?keyName=SWN0026752
				window.open("https://ylwl.haierbiomedical.com/siteWaybillInfo/mdlgenzongDetail?keyName="+sapcode,"_blank");
			},

            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                // if ((column.label == '订单编号' || column.label == 'SAP订单号' || column.label == '经销商编码' || column.label == '经销商名称') && row.orderCategory == '2') {
                //     const _row = this.spanArr[rowIndex];
                //     const _col = _row > 0 ? 1 : 0;
                //     return {
                //         rowspan: _row,
                //         colspan: _col
                //     }
                // }else if ((column.label == '订单状态' || column.label == '操作') &&
                //     (row.status == '10' || row.orderCategory == '2')) {
                //     const _row = this.spanArr[rowIndex];
                //     const _col = _row > 0 ? 1 : 0;
                //     return {
                //         rowspan: _row,
                //         colspan: _col
                //     }
                // }
				if(column.label == '经销商类型' || column.label == '经销商编码' || column.label == '经销商'){
					const _row = this.spanArr[rowIndex];
					const _col = _row > 0 ? 1 : 0;
					return {
						rowspan: _row,
						colspan: _col
					}
				}

            },
            /*↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑行合并↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/




            //查询该用户及所有子用户所有订单详情
            query() {
             	if((this.formInline.delTimeStart!=null && this.formInline.delTimeStart!= "") || (this.formInline.delTimeEnd!=null && this.formInline.delTimeEnd!="")){
            		if(this.formInline.orderCategory==''){
						this.$msg.msge("有实际发货日期查询条件 请选择订单类型！");
						return;
					}
				}
             	if(this.formInline.sapCodeLike){
             		if(this.formInline.date1 == this.newDate1 && this.formInline.date1 == this.newDate1){
             			this.formInline.date1 = null;
						this.formInline.date2 = null;
					}
				}
                ss.OrderMainService.orderProcessPage(this.formInline).then(rd => {
                    if(rd.records && rd.records.length>0){
                        rd.records.forEach((item, index) => {
                            item.delTime = ''
                            //内外销部分时间合并
                            if(item.orderCategory == "1" ){
                                item.arrTime = item.nxFiveTime
                                item.delTime = item.nxThreeTime
                            }else if(item.orderCategory == "2"){
								item.arrTime = item.wxEightTime //当前不存在，待物流系统补充
								item.delTime = item.wxTwoTime
							}
                            else{
                                item.arrTime = item.wxEightTime //当前不存在，待物流系统补充
                                item.delTime = item.wxThreeTime
                            }
                            //如果有工程版本号 则隐藏特价版本号
                            if(item.orderProjectCode){
                                item.specialOfferCode = ''
                            }
                        })
					}
                    this.tableData = rd.records;
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },

            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.multipleSelection.forEach(element => {
                    element.syNum = element.availableNum - element.proNumber;
                });
            },

            // 重置按钮
            resetData() {
                // this.$refs["form"].resetFields();
                this.formInline.wlyjfh='',
				this.formInline.wlyjfh1='',
                this.formInline.soldToAreaCode = '',
                this.formInline.proModelName = '',
                this.formInline.add1 = '',
                this.formInline.soldToAreaCode = '',
                this.formInline.sapCodeLike = "";
                this.formInline.sdfCodeNameLike = "";
				this.formInline.materialCodeNameLike = "";
                this.formInline.orderCategory = "";
                this.formInline.status = "";
                this.formInline.date1 = null;
                this.formInline.date2 = null;
                this.formInline.gaobenchmark = "";
                this.formInline.shifouyidi = "";
                this.formInline.disChannelCode = "";
                this.formInline.billingStatus = '';
                this.formInline.saleGroupCode = '';
                this.formInline.orderCategory1 = "";
                this.formInline.proModelCode = "";
				this.formInline.prodtype = "";
				this.formInline.isBlood = '';
                this.value2='';
				this.formInline.taskEnddateBg = "";
				this.formInline.taskEnddateEd = "";
				this.formInline.businessTime = "";
                this.formInline.thawStatus = "";
                this.formInline.acceptTimeStart = "";
                this.formInline.acceptTimeEnd = "";
				this.formInline.packageOrderCode="";
				this.formInline.delTimeStart="";
				this.formInline.delTimeEnd="";
              this.formInline.chandidata = "";
            },

            //查看订单详情
            handelDetail(row) {
                var instid = null;
                if (row.orderCategory == '1' || row.orderCategory1 == '43' || row.orderCategory1 == '26' || row.orderCategory1 == '30' ) {
                    instid = row.instid;
                } else {
                    instid = row.binstid;
                }
                var routeData = null;
                if (row.orderCategory == '1') {
					this.$router.push({path: '/dingdmain/orderNxshenpi', query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}});
                } else if (row.orderCategory == '2' && row.orderCategory1 != '26' && row.orderCategory1 != '42' && row.orderCategory1 != '43') {
					this.$router.push({path: '/dingdmain/orderWxshenpi', query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}});
                }else if (row.orderCategory == '3') {
					this.$router.push({path: '/dingdmain/orderShshenpi', query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}});
                }else if(row.orderCategory == '2' && row.orderCategory1 == '26'){
                    this.$router.push({path: '/dingdmain/orderNxshenpi', query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}});
                } else if(row.orderCategory == '2' && row.orderCategory1 == '42'){
                  this.$router.push({path: '/dingdmain/orderWxSalesShenpi', query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}});
                }else if(row.orderCategory == '2' && row.orderCategory1 == '43'){
                  this.$router.push({path: '/dingdmain/orderNxshenpi',      query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}});
                }
            },
            changeOrderCate(cate){
                if(cate){
                    this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:cate.id});
                }else{
                    this.orderCategory1List =  [];
                }

            },
            timeSelect() {
                this.formInline.wlyjfh = this.value2[0];
                this.formInline.wlyjfh1 = this.value2[1];
            },
            //批量导出
            //导出Excel
            // downloadExcel() {
            //     this.$msg.confirm("确认导出?", () => {
            //         var idlist = [];
            //         this.multipleSelection.forEach(element => {
            //             idlist.push(element.sapCode);
            //         });
            //         this.formInline.ids = idlist;
            //         updownfile.down("/api/swyl/v1/dingdmain/getOrderExcel?ids=" + this.formInline.ids, this.formInline.ids, "get", "data");
            //     })
            // },

            exportExcel() {
                var strids = _.join(_.map(this.multipleSelection,"bid"),",");
                var form = {
                    wlyjfh:null,
                    wlyjfh1:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,

                    soldToAreaCode: '',
                    proModelName: '',
                    add1: '',
                    status: '',
                    sapCodeLike: '',
                    sdfCodeNameLike: '',
					materialCodeNameLike:'',
                    orderCategory: '',
                    date1: null,
                    date2: null,
                    fhdate1:null,
                    fhdate2:null,
                    gaobenchmark: '',
                    shifouyidi: '',
                    disChannelCode: '',
                    prodtype:null,
                    billingStatus: '',
                    saleGroupCode: '',
                    saleGroupCodeList:[],
                };
                if (strids == '') {
                    form = _.clone(this.formInline);
                }
                form.bid = strids;
                console.log(form.bid);
                updownfile.down("/api/swyl/v1/viewOrderProcess/downloadExcel", form, "post");
                // updownfile.down("/api/swyl/v1/viewOrderProcess/downloadExcelW", form, "post");
            },

            genzongLiuch(r) {
                console.log(r);
                if (r.orderCategory == '1') {
                    this.instid = r.binstid;
                } else {
                    this.instid = r.instid;
                }
                this.showhistory = true;
            },
            imgfalse3() {
                this.imgflag3 = true;
            },
			formatDate(row, column) {
				// 获取单元格数据
				let data = row[column.property]
				if(data == null || data == '') {
					return null
				}
				let dt = new Date(data)
				return this.$util.riQi3(dt);
			},
			/*此方法用于解决最后审核日期为CST格式转换为GMT格式跨时区问题 hyl*/
			formatDateGMT(row, column) {
				// 获取单元格数据
				let data = row[column.property]
				if(data == null || data == '') {
					return null
				}

				var dateStr=data.trim().split(" ");
				var strGMT = dateStr[0]+" "+dateStr[1]+" "+dateStr[2]+" "+dateStr[5]+" "+dateStr[3]+" GMT+0800";
				let dt = new Date(Date.parse(strGMT));
 				return this.$util.riQi3(dt);
			},


			formatDate8(row, column) {
				// 获取单元格数据
				let data = row[column.property]
 				if(data == null || data == '') {
					return null
				}
				return this.$util.riQi8(data);
			},

			setSelectDate(){
				this.formInline.date2 = this.timestampToTime(new Date());
				var newDate = new Date();
				this.formInline.date1 = this.timestampToTime(newDate.getTime()-365/2*24*60*60*1000-24*60*60*1000);// 默认结束日期
				this.newDate1 = this.formInline.date1;
				this.newDate2 = this.formInline.date2;
			},
			// 时间戳转换日期
			timestampToTime(timestamp) {
				var  date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				let Y = date.getFullYear() ;
				let M = (date.getMonth()+1 < 10 ?  '0' +(date.getMonth()+1) : date.getMonth()+1) ;
				let D = date.getDate().toString().padStart(2,0);
				let h = date.getHours() +  ':' ;
				let m = date.getMinutes() +  ':' ;
				let s = date.getSeconds();
				return  Y + '-' + M + '-' + D;//+h+m+s
			},

        },


        mounted() {
        },

    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }

</style>
<style>
	.ddqlcpicker .el-date-editor .el-range-separator {
	    width: 9%;
	    margin-bottom: 0;
	}
	.ddqlcpicker .el-range-editor.el-input__inner{
		padding-right: 0.12rem;
	}
</style>
